var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.$style.cardContainer,
    _vm.$style['topSpacing-' + _vm.topSpacing],
    { [_vm.$style.blank]: _vm.blank }
    ]},[_vm._t("default",function(){return [_vm._v("Content...")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }